<template>
<!-- :label="field.label" -->
    <b-form-group
        
        :label-for="`id_${field._id}`"
        :class="{
            'required-field': field.isRequired,
        }"
    >
    <label
                :class="{
                    'urdu-label': urduLabel,
                }"
                >{{ field.label }}</label
            >
    <!-- <label for=""
                >{{ field.label }}<br v-if="field.breakLine"><span v-if="field.urduLabel" class="urdu-label">({{ field.urduLabel }})</span
            ></label> -->
        <multiselect
            v-model="model"
            v-validate="{
                required: true,
            }"
            :disabled="loading || field.isDisabled"
            :placeholder="field.placeholder"
            :options="formatOptions"
            :label="textField"
            :track-by="valueField"
            :multiple="multiple"
            :taggable="false"
            :data-vv-name="field.label"
            :class="[
                {
                    'is-invalid': errors.has(field.label),
                },
            ]"
            :show-no-results="false"
           
        ></multiselect>
         <!-- @input="onInput" -->
    </b-form-group>
</template>

<script>
import { mapGetters } from 'vuex'

import List from './List.vue'
import Multiselect from 'vue-multiselect'

export default {
    // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        Multiselect,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        textField: {
            type: String,
            default: 'title',
        },
        valueField: {
            type: String,
            default: 'productId',
        },
        multiple: {
            type: Boolean,
            default: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            options: [],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading']),
        urduLabel(){
            if(this.$store.state.registration.form.languageOption == 'urd'){
                return true
            } else {
                return false
            }
        },

        /**
         * format the products list as required
         *
         * @return {void}
         */
        formatOptions() {
            return this.options.map((option) => {
                return {
                    productId: option._id,
                    title: option.title,
                    number: '',
                }
            })
        }, // End of formatOptions() method
    }, // End of Component > computed

    methods: {
        onInput(){
            if(this.field.key == 'contactInfo.isdCode'){
                this.$store.commit('updateField', {
                key: 'pmdaForm.valid',
                value: false,
            })
            }
        }
    }
}
</script>
